// 开直播
import followWorksIndex from '@/views/entertainment/followWorks/index'

const dyRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `followWorks/dy/index${i + 1}`,
  name: `followWorks/dy/Index${i + 1}`,
  component: () => import(`@/views/entertainment/followWorks/dy/index${i + 1}.vue`)
}))
const branchDyhRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `followWorks/dy/branch/index${i + 1}`,
  name: `followWorks/dy/branch/Index${i + 1}`,
  component: () => import(`@/views/entertainment/followWorks/dy/branch/index${i + 1}.vue`)
}))
const mpRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `followWorks/mp/index${i + 1}`,
  name: `followWorks/mp/Index${i + 1}`,
  component: () => import(`@/views/entertainment/followWorks/mp/index${i + 1}.vue`)
}))
const branchMpRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `followWorks/mp/branch/index${i + 1}`,
  name: `followWorks/mp/branch/Index${i + 1}`,
  component: () => import(`@/views/entertainment/followWorks/mp/branch/index${i + 1}.vue`)
}))

const xhsRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `followWorks/xhs/index${i + 1}`,
  name: `followWorks/xhs/Index${i + 1}`,
  component: () => import(`@/views/entertainment/followWorks/xhs/index${i + 1}.vue`)
}))
const branchXhsRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `followWorks/xhs/branch/index${i + 1}`,
  name: `followWorks/xhs/branch/Index${i + 1}`,
  component: () => import(`@/views/entertainment/followWorks/xhs/branch/index${i + 1}.vue`)
}))

export default {
  path: '/entertainment',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'followWorks/index',
      name: 'followWorksIndex',
      component: followWorksIndex
    },
    // 开直播，开始
    ...dyRoutes,
    ...branchDyhRoutes,
    ...mpRoutes,
    ...branchMpRoutes,
    ...xhsRoutes,
    ...branchXhsRoutes

    // 开直播，结束

  ]
}
